const maintenanceTranslate: Record<string, string> = {
  'STATUS.MAINTENANCE.UP_TO_DATE': 'Al día',
  'STATUS.MAINTENANCE.PENDING': 'Pendiente',
}
export default maintenanceTranslate
